const locale = {
	OVERVIEW: 'Übersicht',
	CALENDAR: "Kalender",
	REQUESTS: "Anträge",
	TASKS: "Aufgaben",
	REPORTS: 'Reporte',
	TRIPS: 'Fahrten',
	VEHICLES: 'Fahrzeuge',
	EMPLOYEES: "Mitarbeiter",
	ADMINISTRATION: "Administration",
	CHANGELOG: "Änderungsprotokoll",
	CHANGELOGDESCRIPTION: "Versionshistorie und Versionshinweise",
	EXAMPLE: 'Beispiel',
	EXAMPLE2: 'Beispiel 2',
	EXAMPLE3: 'Beispiel 3',
};

export default locale;
